import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 8.5L14 8.5V10.5L8 16.5L2 10.5V8.5H6V0.5L10 0.5V8.5Z", fill: "#616061" }));
export default SvgArrowDown;
